
<template>
    <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <device-service-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></device-service-form>
  </j-modal>
</template>

<script>

  import DeviceServiceForm from './DeviceServiceForm'

  export default {
    name: 'DeviceServiceModal',
    components: {
      DeviceServiceForm
    },
    data () {
      return {
        title: "设备投运",
        width: 700,
        visible: false,
        disableSubmit: true
      }
    },
    methods: {
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm(this.title === '换新' ? 'retire' : '');
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>